// extracted by mini-css-extract-plugin
export default {"Checkbox":"DeleteUserModal_Checkbox__4q-hy"};